import { fork, all } from 'redux-saga/effects';

import * as UpdateER from './UpdateER';

export default function* rootSaga() {
  yield all([...Object.values(UpdateER)].map(fork));
}
